{
    "id": "1",
    "name": "Main Menu",
    "slug": "main-menu",
    "menu-items": [
        {
            "name": "Video Sync",
            "url": "/",
            "sub-menu": false
        },
        {
            "name": "Pattern Mode",
            "url": "/patterns",
            "sub-menu": false
        },
        {
            "name": "Help",
            "url": "/help",
            "sub-menu": false
        }
    ]

}